import { Pipe, PipeTransform } from '@angular/core';
import { LeadStatusTransition } from 'src/app/core/models/lead/lead-status-transition.model';

@Pipe({
    name: 'transitionCreationDate',
    standalone: false
})
export class TransitionCreationDatePipe implements PipeTransform {

  transform(value: LeadStatusTransition[]): Date | null {
    if (!value || value.length == 0) return null

    return value[0].timeSpan[0]
  }

}
